import React from 'react';
import { Button } from './ui/Button';
export function ResultsSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-white py-10 px-4 md:px-8" data-id="element-148">
      <div className="max-w-4xl mx-auto" data-id="element-149">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-8" data-id="element-150">
          Resultados que Transforman
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-151">
          <div className="bg-blue-50 p-6 rounded-2xl border border-blue-100" data-id="element-152">
            <h3 className="text-2xl font-bold text-blue-900 mb-4 text-center" data-id="element-153">
              Para tus estudiantes
            </h3>
            <ul className="space-y-3" data-id="element-154">
              {['Comprenden mejor los contenidos', 'Participan más en clase', 'Trabajan con actividades claras', 'Aprenden con estructura', 'Conectan lo aprendido con su realidad'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-155">
                  <span className="text-blue-600 font-bold text-lg" data-id="element-156">✔</span>
                  <span className="text-gray-800" data-id="element-157">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-green-50 p-6 rounded-2xl border border-green-100" data-id="element-158">
            <h3 className="text-2xl font-bold text-green-900 mb-4 text-center" data-id="element-159">
              Para vos como maestra
            </h3>
            <ul className="space-y-3" data-id="element-160">
              {['Ahorrás semanas de planificación', 'Enseñás con seguridad', 'Tenés todo organizado', 'Empezás marzo con todo listo', 'Recuperás tiempo personal'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-161">
                  <span className="text-green-600 font-bold text-lg" data-id="element-162">✔</span>
                  <span className="text-gray-800" data-id="element-163">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="text-center" data-id="element-164">
          <Button onClick={scrollToPricing} pulse className="text-xl px-10 py-4" data-id="element-165">
            👉 QUIERO ESTO PARA MI AÑO ESCOLAR
          </Button>
        </div>
      </div>
    </section>;
}